import Head from 'next/head'
import shopInfos from 'template/infos'

const { name, url } = shopInfos

interface SeoProps {
  title?: string
  description?: string
  keywords?: string
  canonical?: string  // Optional: canonical URL
}

const Seo: React.FC<SeoProps> = ({ title, description, keywords, canonical }) => {
  const validTitle = title && title.trim() !== "" ? `${title} | ${name}` : `Suche auf ${name}`;
  const validDescription = description && description.trim() !== "" ? description : "Finde hier das passende Produkt.";
  const validKeywords = keywords && keywords.trim() !== "" ? keywords : undefined;
  // Hier wird die canonical URL gebaut: wenn ein Wert vorhanden ist, wird er an die Shop-URL angehängt, sonst wird der Standardwert genutzt.
  const validCanonical = canonical && canonical.trim() !== "" ? `${url}${canonical}` : `${url}suche`;

  return (
    <Head>
      <title>{validTitle}</title>
      <meta name="description" content={validDescription} />
      {validKeywords && <meta name="keywords" content={validKeywords} />}
      <link rel="canonical" href={validCanonical} />
    </Head>
  );
}

export default Seo;